import { GAME_ID } from '../../data/constants';
import { persistStateTypes } from '../../../reducers/persistStateReducer';

const initialState = {};

// Handles persistent data

const gameDetailsReducer = (state = initialState, { gameId, type, stateData }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // update state when gamestate data has been received
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE:
      return {
        ...state,
        ...(stateData[GAME_ID].GameData || {}).gameDetails,
      };

    default:
      return state;
  }
};

export default gameDetailsReducer;
